export const CLEAR_ALL_ERROR_MSGS = "CLEAR_ALL_ERROR_MSGS";

export default function clearAllMessage() {
  return {
    type: CLEAR_ALL_ERROR_MSGS,
    payload: { },
  };
}